export class SignatureContrat {
    IDSignatureParametreContrat?: number
    IDSignatureParametre?: number
    NoCmd!: string
    CreditsAchetes!: number
    CreditsConsommes?: number
    DateCre?: Date
    DateUpd?: Date

    constructor(data?: Partial<SignatureContrat>) {
        Object.assign(this, data)
        this.CreditsConsommes = this.CreditsConsommes || 0
    }
}